import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';

import { store } from './store/store';
import App from './App';
import GlobalStyles from './global';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <>
    <meta
      name="viewport"
      content="width=device-width, initial-scale=1, minimum-scale=1, maximum-scale=1, user-scalable=0"
    />
    <React.StrictMode>
      <GlobalStyles />
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  </>,
);

reportWebVitals();
